import { getSelectedCalendarsFromTimePanel } from './getSelectedCalendarsFromTimePanel';
import { hasTimePanelSelectedCalendars } from './hasTimePanelSelectedCalendars';
import { getTimePanelConfigLoadStates } from '../selectors/getTimePanelConfigLoadStates';
import { ConfigLoadState } from '../store/schema/TimePanelSelectedCalendarIdsStore';
import { ObservableMap } from 'mobx';
import { getSelectedCalendars as getSelectedCalendarsFromCalendarModule } from 'owa-calendar-module-selected-calendars-user-config';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Gets selected calendarIds as a map of accounts to calendarIds, preferably from Time Panel config
 * if non-empty or else fall back to Calendar module config
 */
export function getTimePanelSelectedCalendarIdsMap(): ObservableMap<string, string[]> {
    // always reference calendar module config outside of feature flight (regardless of settings load state)
    if (!isFeatureEnabled('cal-time-panel-calendarPicker')) {
        return getSelectedCalendarsFromCalendarModule();
    }

    // reference Time Panel config while loading settings or if settings are loaded and non-empty
    const configLoadStates = getTimePanelConfigLoadStates();
    const isNotInitialized = configLoadStates.size === 0;
    const hasLoadedAnyConfigs = [...configLoadStates.values()].some(
        value => value === ConfigLoadState.Loaded
    );
    if (isNotInitialized || (hasLoadedAnyConfigs && hasTimePanelSelectedCalendars())) {
        return getSelectedCalendarsFromTimePanel();
    }

    // otherwise fall back to calendar module config
    return getSelectedCalendarsFromCalendarModule();
}
